// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__6Hi52","table__container":"styles_table__container__3dYca","main__heading":"styles_main__heading__1nshq","icon":"styles_icon__38gKW"};